module.exports = __webpack_public_path__ + "img/20190530161156168.b4d05c06.png";